import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const Bowl: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
    <Path fill-rule='evenodd' clip-rule='evenodd' d='M22 7C22 12.5225 17.5225 17 12 17C6.47703 17 2 12.5225 2 7H22Z' />
  </SVG>
);
